<app-wizard-modal
  [vertical]="true"
  [isLoading]="isLoading"
  (stepChange)="onStepChange($event)"
  (cancel)="onWizardCancel()"
  (submit)="onWizardSubmit()">

  <app-wizard-title>
    {{ 'admin.tools.bulkReset.title' | translate }}
  </app-wizard-title>

  <!-- Step 1: Scanning -->
  <app-wizard-step [canContinue]="allScanned">
  <ng-template #title>
    {{ 'admin.tools.bulkReset.step1.title' | translate }}
  </ng-template>
  <ng-template #content>
      <app-alert
        *ngIf="!allScanned"
        type="warning"
        [message]="'admin.tools.bulkReset.notAllScanned' | translate">
      </app-alert>
    <app-tool-reset-form
      [isScanListenerActive]="true"
      [scannedTools]="bulkReset.tools"
      (toolWasScanned)="onToolScanned($event)">
    </app-tool-reset-form>
  </ng-template>
</app-wizard-step>

  <!-- Step 2: Overview -->
  <app-wizard-step>
    <ng-template #title>
      {{ 'admin.tools.bulkReset.step2.title' | translate }}
    </ng-template>
    <ng-template #content>
      <app-alert
        *ngIf="anyInUse"
        type="warning"
        [message]="'admin.tools.bulkReset.someInUse' | translate">
      </app-alert>
      <div class="overview">
        <div class="changes">
          <div class="title">
            {{ 'admin.tools.bulkReset.overview' | translate }}
          </div>
          <ul>
            <li *ngFor="let tool of bulkReset.tools">
              {{ tool.name }}
            </li>
          </ul>
        </div>
      </div>
    </ng-template>
  </app-wizard-step>
</app-wizard-modal>
